import { render, staticRenderFns } from "./match_report.vue?vue&type=template&id=75367366&scoped=true"
import script from "./match_report.vue?vue&type=script&lang=js"
export * from "./match_report.vue?vue&type=script&lang=js"
import style0 from "./match_report.vue?vue&type=style&index=0&id=75367366&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75367366",
  null
  
)

export default component.exports